import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postMarkProjectAsDone = (
    backend: string,
    token: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}markProjectEmployeeDoneMarker/${id}`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    );
};

export default postMarkProjectAsDone;
